<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs :crm_id="this.$route.params.crmid"/>
            <div class="question-wrap clearfix">
              <!--<el-button type="warning">举报</el-button>-->
              <jm-tableList
                url="/index/question/student"
                :search-data="{ crm_id: this.$route.params.crmid }"
                :refresh="refresh">
                <el-table-column
                  slot="lastColumn"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button
                      class="btn-tableEdit"
                      size="small"
                      :type="items.type"
                      :disabled="!items.actived"
                      @click="handleButton(scope.row, items.label)"
                      v-for="items in scope.row.buttons"
                      :key="items.label">{{ items.label }}</el-button>
                  </template>
                </el-table-column>
              </jm-tableList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      textarea: '',
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
  },
  methods: {
    /**
     * Description: 按钮操作
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleButton(item, status) {
      let routeData = '';
      switch (status) {
        case '编辑':
          routeData = this.$router.resolve({
            name: 'questionAnswer',
            params: { crmid: this.$route.params.crmid, questionId: item.questionId }
          });
          window.open(routeData.href, '_blank');
          break;
        case '转问':
          this.turnAsk(item);
          break;
        case '删除':
          this.delAsk(item);
          break;
        default:
          return false;
      }
    },
    /**
     * Description: 删除消息
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    delAsk(item) {
      this.$confirm('此操作是永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: 'index/question/dropQuestion',
          data: {
            tag: item.tag,
            questionId: item.questionId
          }
        }).then((data) => {
          if (data.result !== -1) {
            this.$message.success('删除成功!');
            this.$store.commit('updateRefresh', true);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**
     * Description: 转问消息
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    turnAsk(item) {
      this.$confirm('此操作是转问消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: 'index/question/moveQuestion',
          data: {
            tag: item.tag,
            questionId: item.questionId
          }
        }).then((data) => {
          if (data.result !== -1) {
            this.$message.success('转问成功!');
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  },
  computed: {
    /*
     * 监听 状态刷新数据
     * */
    refresh() {
      return this.$store.state.student.refresh;
    },
  },
  mounted() {
  },
};
</script>
<style scoped>
  .btn-tableEdit{
    margin: 5px 5px 5px 0;
  }
</style>
